const config = {
  mainTitle: 'Inventory',
  subHeading: 'A page to check current inventory',
  titleIcon: 'MdArchive',
  headers: [
    'Item Name',
    'Item Type',
    'Item Subtype',
    'Calc Amount',
    'Input Amount',
    ''
  ],
  updateHeaders: [
    'Item Name',
    'Update Date',
    'Old Value (Input)',
    'New Value (Input)',
    'Old Value (Calc)',
    'New Value (Calc)'
  ],
  locations: ['Redhill', 'Kingston']
}

export default config
